import { checkValidityErrorHTML } from "./utils";
import { $, requestSuccess } from "../vanilla/utils";
import { brazilianstates } from "../shared/brazilianstates";
import { checkValidityError, setAsValid, setAsInvalid } from "../shared/validation-utils";
import nanoajax from "nanoajax";

export const serchingCEP = searching => {
	if (searching) {
		$("#cep_loader").style.display = "block";
		$("#register_address").disabled = true;
		$("#address_number").disabled = true;
		$("#address_complement").disabled = true;
		$("#register_neighborhood").disabled = true;
		$("#address_state").disabled = true;
		$("#no_number").disabled = true;
		$("#address_city").disabled = true;
	} else {
		$("#cep_loader").style.display = "none";
		$("#register_address").disabled = false;
		$("#address_number").disabled = false;
		$("#address_complement").disabled = false;
		$("#register_neighborhood").disabled = false;
		$("#address_state").disabled = false;
		$("#no_number").disabled = false;
		$("#address_city").disabled = false;
	}
};

const disableISS = value => {
	if (value && value === "Belo Horizonte") {
		$("#iss_retido").disabled = false;
		$("#iss_retido").value = false;
	} else {
		$("#iss_retido").disabled = true;
	}
};

export const onChangeCity = event => {
	checkValidityError(event);
	disableISS(event.target.value);
};

export const checkCEP = event => {
	const el = event.target;
	if (el.value.length < 9) {
		setAsInvalid(el, "CEP inválido ou inexistente");
		el.setAttribute("hasBusinessError", "true");
	} else {
		setAsValid(el);
		el.removeAttribute("hasBusinessError");
		serchingCEP(true);
		const addressInput = $("#register_address"),
			neighborhoodInput = $("#register_neighborhood"),
			citySelect = $("#address_city"),
			stateInput = $("#address_state");
		//TODO set default url
		nanoajax.ajax(
			{
				url: `/search-cep?cep=${el.value.replace("-", "")}`
			},
			(code, responseJSON) => {
				try {
					if (requestSuccess(code)) {
						const address = JSON.parse(responseJSON);

						handleStateChange(address.uf, address.cidade);
						addressInput.value = address.logradouro;
						neighborhoodInput.value = address.bairro;
						stateInput.value = address.uf;
						checkValidityErrorHTML(addressInput);
						checkValidityErrorHTML(neighborhoodInput);
						checkValidityErrorHTML(stateInput);
					} else {
						setAsValid(el);
						el.removeAttribute("hasBusinessError");
						addressInput.value = "";
						neighborhoodInput.value = "";
						citySelect.value = "";
						stateInput.value = "";
					}
					serchingCEP(false);
				} catch (err) {
					serchingCEP(false);
				}
			}
		);
	}
};

export const setToNoNumber = () => {	
	const noNumberCb = $("#no_number");
	const numberInput = $("#address_number");
	numberInput.type = 'text';
	numberInput.disabled = noNumberCb.checked;
	numberInput.value = noNumberCb.checked ? "S/N" : "";
	if (noNumberCb.checked) {		
		checkValidityErrorHTML(numberInput);
	}
	else {
		numberInput.type = 'number';
	}
};

export const loadingSearchCities = loading => {
	if (loading) {
		$("#address_city").disabled = true;
	} else {
		$("#address_city").disabled = false;
	}
};

export const handleStateChange = (event, newValue) => {
	const uf = event.target ? event.target.value : event;
	loadingSearchCities(true);
	//TODO set default url
	nanoajax.ajax(
		{
			url: `/search-cities?uf=${uf}`
		},
		(code, responseJSON) => {
			try {
				if (requestSuccess(code)) {
					const response = JSON.parse(responseJSON);
					setCityOptions(response, newValue);
				}
				loadingSearchCities(false);
			} catch (err) {
				loadingSearchCities(false);
			}
		}
	);

	if (event.target) {
		checkValidityError(event);
	}
};

export const setBrasilianStates = () => {
	const HTMLstates = `<option id="option-placeholder" value=""> Selecione </option>
		${brazilianstates
			.map(
				state =>
					`<option value="${state.abbrev}" key="${state.abbrev}">
				${state.name}
			</option>`
			)
			.join()}`;

	const selectStates = $("#address_state");
	selectStates.innerHTML = HTMLstates;
};

export const setCityOptions = (cities, newValue) => {
	const HTMLcities = `<option id="option-placeholder" value=""> Selecione </option>
		${cities
			.map(
				state =>
					`<option value="${state.name}" key="${state.name}">
				${state.name}
			</option>`
			)
			.join()}`;
	const selectCities = $("#address_city");
	selectCities.innerHTML = HTMLcities;
	if (newValue !== undefined) {
		setTimeout(() => {
			selectCities.value = newValue;
			checkValidityErrorHTML(selectCities);
			disableISS(newValue);
		}, 1);
	}
};
